import React from 'react';

export type TypeBadgeKind =
  | 'Task'
  | 'Outcome'
  | 'Project'
  | 'Tag'
  | 'Person'
  | 'Team'
  | 'WorkflowInstance'
  | 'Unknown'
  | 'Item';

interface Props {
  t: TypeBadgeKind;
  size?: 'xs' | 'sm';
}

const TypeBadge: React.FC<Props> = ({ t, size = 'xs' }) => {
  const base = size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-xxs text-[10px] px-1 py-0.5';
  const cls = `${base} rounded`;
  switch (t) {
    case 'Task':
      return <span className={`${cls} bg-blue-100 text-blue-800 dark:bg-blue-900`}>Task</span>;
    case 'Outcome':
      return <span className={`${cls} bg-green-100 text-green-800 dark:bg-green-900`}>Outcome</span>;
    case 'Project':
      return <span className={`${cls} bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300`}>Project</span>;
    case 'Tag':
      return <span className={`${cls} bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300`}>Tag</span>;
    case 'Person':
      return <span className={`${cls} bg-sky-100 text-sky-800 dark:bg-sky-900 dark:text-sky-300`}>Person</span>;
    case 'Team':
      return <span className={`${cls} bg-pink-100 text-pink-800 dark:bg-pink-900 dark:text-pink-300`}>Team</span>;
    case 'WorkflowInstance':
      return <span className={`${cls} bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-300`}>Workflow</span>;
    default:
      return <span className={`${cls} bg-cm-border-subtle text-cm-text-primary`}>Item</span>;
  }
};

export default TypeBadge;
